import { createFeatureSelector, createSelector } from '@ngrx/store'
import { EbCartModification } from '../../interface/eb-cart.interface'
import { STORE_FEATURE_EB_MULTI_CART } from '../../interface/eb-multi-cart-state.interface'

const getEbMultiCartState = createFeatureSelector<EbCartModification[]>(STORE_FEATURE_EB_MULTI_CART)

export const getCartModifications = createSelector(
  getEbMultiCartState,
  (state: EbCartModification[]) => state
)
